// Styles for MerchandisingDCAContainer go here.
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
const { md } = { ...baseVariables.mediaQuery };

export const StyledDCADecisionContainer = styled.div`
  .dca-decision-content {
    transition: width 2s ease, height 2s ease, aspect-ratio 2s ease, max-height 2s ease, max-width 2s ease;

    &[data-variation='riott-media'] {
      width: 100%;
      min-height: 300px;
      @media ${md} {
        aspect-ratio: 570 / 49;
        min-height: auto;
      }
    }

    &[data-variation='riott-media-non-mobile'] {
      width: 100%;
      min-height: auto;
      @media ${md} {
        aspect-ratio: 570 / 49;
      }
    }

    &[data-variation='small_banner'],
    &[data-variation='small_banner_v2'],
    &[data-variation='small_banner_v3'] {
      aspect-ratio: 182 / 116;
      @media ${md} {
        aspect-ratio: 570 / 49;
      }
    }

    &[data-variation='partner-card'],
    &[data-variation='tile-square'],
    &[data-variation='tile-wide'] {
      aspect-ratio: inherit;
    }
  }

  .skeleton-loader-composite {
    background-color: #d2d2d2;
    color: ${baseVariables.color.merch50};
    -webkit-animation: fadein 1s ease-in alternate infinite;
    -moz-animation: fadein 1s ease-in alternate infinite;
    animation: fadein 1s ease-in alternate infinite;
    border-radius: 8px;
  }
  @-webkit-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @-moz-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }

  .container > div.aem-container {
    padding: 0;
  }

  [data-component-name='o-merch-MerchandisingSmallBanner'] > div {
    margin: 0 !important;
    padding-bottom: 0 !important;
    @media ${md} {
      padding: 0 !important;
    }
  }

  [data-component-name='o-merch-RiottMedia'] {
    .riott-media__width {
      margin: 0 !important;
    }
  }

  html[dir='rtl'] & .dca-decision-content {
    &::before,
    &::after {
      display: table;
      content: ' ';
    }

    &::after {
      clear: both;
    }
  }
`;
